module.exports = __webpack_public_path__ + "static/media/algunas-comidas.e3a0c160.svg";